import Icon from 'veui/components/Icon'
import { IconAudio } from 'dls-icons-vue'

Icon.register('audio', IconAudio)
